import { IsString } from 'class-validator';

export class RG {
  @IsString()
  numero: string;

  @IsString()
  orgaoEmissor: string;
}
